document.addEventListener('DOMContentLoaded', () => {
    const mainContent = document.querySelector('#article-top');
    const rawContent = document.querySelector('#article-content .shogun-root').innerHTML;

    mainContent.innerHTML = rawContent;  

    // Create a temporary container to parse the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawContent;

    // Get all h2 elements
    const shogunHeaders = Array.from(tempDiv.querySelectorAll('.shg-align-left'));

    // Identify the middle header
    const firstBreakIndex = Math.floor(shogunHeaders.length / 3);
    const secondBreakIndex = Math.floor(2 * shogunHeaders.length / 3);
    const firstBreakHeader = shogunHeaders[firstBreakIndex];
    const secondBreakHeader = shogunHeaders[secondBreakIndex];

    // Create two containers for the split content
    const firstContainer = document.createElement('div');
    const secondContainer = document.createElement('div');
    const thirdContainer = document.createElement('div');
    firstContainer.className = 'split-content first-part';
    secondContainer.className = 'split-content middle-part';
    thirdContainer.className = 'split-content last-part';

    // Use a flag to determine which container to append to
    let appendToSecond = false;
    let appendToThird = false;

    // Loop through all child nodes in the parsed content
    Array.from(tempDiv.childNodes).forEach(node => {
      if (node.isEqualNode(firstBreakHeader)) {
        console.log("found middle")
        appendToSecond = true; // Switch to the second container after the first break
      }
      else if (node.isEqualNode(secondBreakHeader)){
        appendToSecond = false;
        appendToThird = true; // Switch to the third container after the second break
      }
      if (appendToSecond){
        secondContainer.appendChild(node.cloneNode(true));
      }
      else if (appendToThird) {
        thirdContainer.appendChild(node.cloneNode(true));
      } else {
        firstContainer.appendChild(node.cloneNode(true));
      }
    });

    // Clear the original content and append the two halves
    mainContent.innerHTML = '';
    mainContent.appendChild(firstContainer);

    //need to append the product CTA to the bottom of the top portion
    const ctaContent = document.querySelector('.inline-product-cta').innerHTML;
    const ctaContainer = document.createElement('div');
    ctaContainer.innerHTML = ctaContent;
    mainContent.appendChild(ctaContainer);

    secondContent = document.querySelector('#article-middle');
    secondContent.appendChild(secondContainer);

  //need to append the product CTA to the bottom of the top portion
    const socialCtaContent = document.querySelector('.article-share-cta').innerHTML;
    const socialCtaContainer = document.createElement('div');
    socialCtaContainer.innerHTML = socialCtaContent;
    thirdContent = document.querySelector('#article-bottom');
    thirdContent.appendChild(thirdContainer);
    thirdContent.appendChild(socialCtaContainer);

    //NOW SET UP TABLE OF CONTENTS

    // Select all h2 elements in article
    const h2Elements = document.querySelectorAll('#article-top h2, #article-middle h2, #article-bottom h2');
    
    // Extract the text content of these h2 elements
    const h2Texts = Array.from(h2Elements).map(h2 => h2.textContent.trim()); // Trims any extra whitespace
   
    console.log(h2Texts); // Logs the array of text content
    
    // Find the target container where the texts will be displayed
    const targetContainer = document.getElementById('article-toc'); // Replace with your container's IDa
    h2Texts.forEach((text, index) => {
      const newElement = document.createElement('p'); // Create a new <p> element for each text
      newElement.setAttribute("id", "toc-item-"+index.toString());
      newElement.classList.add('toc-item');
      newElement.textContent = text; // Set the text content
      
      // Add a click event to scroll to the corresponding h2 element
      newElement.addEventListener('click', () => {
        h2Elements[index].scrollIntoView({
          behavior: 'smooth', // Smooth scrolling animation
          block: 'center' // Scroll to the top of the element
        });
      });

      // Append the new element to the target container
      targetContainer.appendChild(newElement);
    });

  });


  document.addEventListener('DOMContentLoaded', () => {
    const h2Elements = document.querySelectorAll('#article-top h2, #article-middle h2, #article-bottom h2');
    const tocElements = document.querySelectorAll(".toc-item")
    // Create an IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      let closestElement = null;
      let smallestOffset = Infinity;
      
      const viewportCenter = window.innerHeight / 2;
  
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Calculate distance from the top of the viewport
          const elementCenter = entry.boundingClientRect.top + entry.boundingClientRect.height / 2;
          const offset = Math.abs(viewportCenter - elementCenter);
  
          if (offset < smallestOffset) {
            smallestOffset = offset;
            closestElement = entry.target;
          }
        }
      });
  
      // Highlight or log the closest element
      if (closestElement) {
        // Optionally add a class to highlight the closest element
        tocElements.forEach((tocItem) => {
          tocItem.classList.remove('selected-toc-item')
          if (closestElement.textContent.includes(tocItem.textContent)){
            tocItem.classList.add('selected-toc-item');
          }
        });
      }
    }, {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.5 // Trigger when 10% of the element is visible
    });
  
    // Observe all h2 elements
    h2Elements.forEach((h2) => observer.observe(h2));
  });
  
    //Get the button:
    mybutton = document.getElementById("myBtn");
  
    // When the user scrolls down 500px from the top of the document, show the button
    window.addEventListener('scroll', scrollFunction);
  
    function scrollFunction() {
      if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  
    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    // JavaScript function to copy the current page URL to the clipboard
    function copyToClipboard() {
      const pageUrl = window.location.href; // Get the current page URL
      navigator.clipboard.writeText(pageUrl).then(() => {
          alert('URL copied to clipboard!');
      }).catch(err => {
          console.error('Error copying URL:', err);
      });
  }
